import formatTimeWithAliases from '@anm/helpers/time/formatTimeWithAliases';

export const getPlaysTimeLabel = (seconds: number) =>
  `${formatTimeWithAliases(seconds)}`;
